module.exports = __webpack_public_path__ + "img/f7.6a1a07e7.png";